import { render, staticRenderFns } from "./SelectFreight.vue?vue&type=template&id=4329a039"
import script from "./SelectFreight.vue?vue&type=script&lang=js"
export * from "./SelectFreight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports